/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

export { DetailsPageLoading } from './details-loading';
